import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Steps: ComponentStyleConfig = {
  parts: [
    'StepsContainer',
    'Step',
    'StepConnector',
    'StepConnectorElement',
    'StepIcon',
    'StepDetails',
    'StepTitle',
    'StepDescription',
  ],
  baseStyle: (props: StyleFunctionProps) => {
    const { colorScheme, status } = props;
    const color = colorScheme !== undefined ? colorScheme : 'gray';

    return {
      StepsContainer: {
        w: 'full',
        justifyContent: 'space-between',
        my: 2,
        alignItems: 'center',
      },
      Step: {
        flexDirection: 'row',
        alignItems: 'center',
        py: 1,
        pr: 2,
        pl: 2,
        width: '80%',
        borderRadius: 'lg',
        cursor: 'pointer',
        color: mode('black', 'white')(props),
        bg: mode('white', 'gray.900')(props),
        position: 'relative',
        minW: 'max-content',
        maxW: 'fit-content',
      },
      StepIcon: {
        h: 6,
        w: 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 'full',
        border: '1px solid',
        mr: -2,
        color:
          status === 'process' || status === 'finish'
            ? 'white'
            : status === 'error'
            ? mode('red.600', 'red.500')
            : mode('gray.500', 'gray.500'),
        borderColor:
          status === 'finish'
            ? mode(`green.600`, `green.400`)
            : status === 'process'
            ? mode(`${color}.600`, `${color}.400`)
            : status === 'error'
            ? mode('red.600', 'red.500')
            : mode('gray.500', 'gray.500'),
        bg:
          status === 'finish'
            ? mode(`green.600`, `green.400`)
            : status === 'process'
            ? mode(`${color}.600`, `${color}.400`)
            : status === 'error'
            ? 'white'
            : mode('gray.100', 'gray.500'),
      },
      StepDetails: {
        flexDirection: 'column',
        p: 2,
      },
      StepTitle: {
        fontSize: 'sm',
        textColor:
          status === 'error'
            ? 'red'
            : status === 'wait'
            ? mode(`gray.400`, `gray.400`)
            : mode('black', 'white'),
      },
      StepDescription: {
        color: 'gray.600',
        fontSize: 'sm',
        textColor:
          status === 'error'
            ? 'red'
            : status === 'wait'
            ? mode(`gray.400`, `gray.400`)
            : mode('gray.800', 'gray.100'),
      },
      StepConnector: {
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
      },
      StepConnectorElement: {
        bg: mode('gray.300', 'gray.100'),
        borderColor: mode('gray.300', 'gray.100'),
        width: '100%',
      },
    };
  },
};

export default Steps;
